export const NOTICE_LIST_PAGE_PATH = '/notice/list'

export const NOTICE_CREATE_PAGE_PATH = '/notice/create'

export const NOTICE_EDIT_PAGE_PATH = '/notice/edit'

export const NOTICE_DETAIL_PAGE_PATH = '/notice/detail'
